import CardFees from './CardFees';
import DiscountCoupon from './DiscountCoupon';
import EventTicketSimple from './EventTicketSimple';
import PaymentGateway from './PaymentGateway';
import Tickets from './Tickets';

export default interface TicketPayment {
  id: string;
  eventTickets: EventTicketSimple[];
  allowSellingWebsite: boolean;
  allowSellingPos: boolean;
  allowPaymentCredit: boolean;
  creditWebsiteGateway?: PaymentGateway;
  creditPosGateway?: PaymentGateway;
  allowPaymentDebit: boolean;
  debitWebsiteGateway?: PaymentGateway;
  debitPosGateway?: PaymentGateway;
  allowPaymentPIX: boolean;
  pixWebsiteGateway?: PaymentGateway;
  pixPosGateway?: PaymentGateway;
  allowPaymentBankSlip: boolean;
  bankslipWebsiteGateway?: PaymentGateway;
  bankslipPosGateway?: PaymentGateway;
  allowFractionalPayment: boolean;
  printReceipt: boolean;
  physicalSale?: CardFees;
  websiteSale?: CardFees;
  allowDiscountCoupon: boolean;
  discountCoupons: DiscountCoupon[];
}

export const parseTicketPayments = (
  tickets: Tickets[] | undefined,
): TicketPayment[] | undefined => {
  if (tickets && tickets.length > 0) {
    const list: TicketPayment[] = [];
    tickets.forEach(data => {
      let found = false;
      const eventTicket: EventTicketSimple = {
        id: data.id,
        name: data.name,
      };
      if (data.payment && data.payment.id && data.payment.id.trim().length > 0) {
        const paymentId = data.payment.id;
        list.forEach(payment => {
          if (payment.id === paymentId) {
            payment.eventTickets.push(eventTicket);
            found = true;
          }
        });

        if (!found) {
          const ticketPayment: TicketPayment = {
            id: paymentId,
            eventTickets: [],
            allowSellingWebsite: data.payment.allowSellingWebsite,
            allowSellingPos: data.payment.allowSellingPos,
            allowPaymentCredit: data.payment.allowPaymentCredit,
            creditWebsiteGateway: data.payment.creditWebsiteGateway,
            creditPosGateway: data.payment.creditPosGateway,
            allowPaymentDebit: data.payment.allowPaymentDebit,
            debitWebsiteGateway: data.payment.debitWebsiteGateway,
            debitPosGateway: data.payment.debitPosGateway,
            allowPaymentPIX: data.payment.allowPaymentPIX,
            pixWebsiteGateway: data.payment.pixWebsiteGateway,
            pixPosGateway: data.payment.pixPosGateway,
            allowPaymentBankSlip: data.payment.allowPaymentBankSlip,
            bankslipWebsiteGateway: data.payment.bankslipWebsiteGateway,
            bankslipPosGateway: data.payment.bankslipPosGateway,
            allowFractionalPayment: data.payment.allowFractionalPayment,
            printReceipt: data.payment.printReceipt,
            physicalSale: data.payment.physicalSale,
            websiteSale: data.payment.websiteSale,
            allowDiscountCoupon: data.payment.allowDiscountCoupon,
            discountCoupons: data.payment.discountCoupons,
          };
          ticketPayment.eventTickets.push(eventTicket);
          list.push(ticketPayment);
        }
      }
    });
    return list;
  }
  return undefined;
};
